module.exports = __webpack_public_path__ + "static/shuttle-bus-955290edfdc936a2a11ae562a042c51d.pdf";